import { Button, RemoveIcon } from "melco-ui";
import { Key } from "react";
import { useTranslation } from "react-i18next";
import { useAddRemoveMachineGroups } from "../../../hooks/reporting/useAddRemoveMachineGroup";

export type BulkActionRemoveMachineGroupsProps = {
  selectedRowKeys: Key[];
  setSelectedRowKeys: (keys: Key[]) => void;
};

export const BulkActionRemoveGroups: React.FC<
  BulkActionRemoveMachineGroupsProps
> = ({ selectedRowKeys, setSelectedRowKeys }) => {
  const { removeGroups } = useAddRemoveMachineGroups();

  const { t } = useTranslation();

  const idsToRemove = selectedRowKeys.map((srk) => {
    return {
      id: srk as string,
    };
  });

  return (
    <>
      {selectedRowKeys.length > 0 && (
        <Button
          icon={<RemoveIcon />}
          onClick={() => {
            removeGroups(idsToRemove);
            setSelectedRowKeys([]);
          }}
        >
          {t("reporting.machinestatus.remove")}
        </Button>
      )}
    </>
  );
};
